// extracted by mini-css-extract-plugin
export default {"close":"Close-module__close___SNJKP"};